import React from 'react'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Typography,
    Chip,
    Paper
} from '@material-ui/core';

import formatDate from '../../utils/formatDate';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        minHeight: '20rem',
    },
    name: {
        color: theme.palette.info.main,
        fontSize: '1.8rem',
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        lineHeight: 1.3,
    },
    updateDate: {
        marginBottom: theme.spacing(1.5),
        fontSize: '1.4rem',
    },
    areaTag: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontSize: '1.2rem',
        fontWeight: 600,
        marginLeft: theme.spacing(1),
    },
    introduction: {
        whiteSpace: 'pre-wrap',
        fontSize: '1.4rem',
        lineHeight: 1.6,
        color: theme.palette.text.primary,
    },
}));

const PersonalProfileCard = props => {
    const classes = useStyles();
    const { user } = props;
    // let introduction = user.profile.introduction.length > 200 ? user.profile.introduction.substr(0, 200) + '...' : user.profile.introduction;

    return (
        <Box className={`${classes.root} ${props.className}`}>
            <Typography variant="h6" className={classes.name}>
                {user.name}
                <Chip
                    label={user.profile.area ? user.profile.area.name : 'エリア指定無し'}
                    className={classes.areaTag}
                    size="small"
                />
            </Typography>
            <Typography variant="body2" className={classes.updateDate}>
                <strong>更新日:</strong> {formatDate(user.updated_at)}
            </Typography>
            <Typography className={classes.introduction}>
                {user.profile.introduction}
            </Typography>
        </Box>
    )
}

PersonalProfileCard.propTypes = {
    user: PropTypes.object
}

export default PersonalProfileCard
